module.exports = __webpack_public_path__ + "img/alberto-andrade.d3f54c5b.png";